import React, { useEffect } from 'react';
import Button from '@mui/material/Button';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom'
import * as actions from '../../../reducers/form';
import { journalTypesAddOne, journalCategoriesGetList } from '../../../api/list'
import { getAccountsTListAPI } from '../../../api/tariff.api'
import validateProps from '../../../functions/validateProps'
import { enqueueSnackbar } from '../../../reducers/notifier'
import SimpleAdd from '../../../components/SimpleAdd'

const formName = 'JournalTypesAdd'
const arrProps = [
  {
    field: 'categoryId', type: 'autoLoad', label: 'Инвестор',
    textProps: {
      path: journalCategoriesGetList.path,
      meta: {
        field: 'category',
        value: 'id',
        labelFunc: (obj) => obj.code + ' ' + obj.name
      }
    }
  },
  {
    field: 'code', label: 'Код', type: 'text', textProps: { inputProps: { maxLength: 50 } },
    validator: [value => value !== ''], errorText: 'Поле обязательно',
  },
  {
    field: 'name', label: 'Наименование', type: 'text',
    validator: [value => value !== ''], errorText: 'Поле обязательно',
  },
  {
    field: 'gostRef', label: 'ГОСТ', type: 'text', textProps: { inputProps: { maxLength: 100 } },
    validator: [value => value !== ''], errorText: 'Поле обязательно',
  },
  {
    field: 'tableNameData', label: 'Таблица данных', type: 'text', textProps: { inputProps: { maxLength: 50 } },
    validator: [value => value !== ''], errorText: 'Поле обязательно',
  },
  { field: 'reportTemplatePath', label: 'Шаблон для печати', type: 'text', },
  { field: 'description', label: 'Описание', type: 'text', },
  {
    field: 'accountIdUnique', type: 'autoLoad', label: 'Инвестор',
    textProps: {
      path: getAccountsTListAPI.path,
      meta: {
        field: 'accounts',
        value: 'id',
        labelFunc: (obj) => obj.name + ' ' + obj.inn
      },
      selectProps: { isClearable: true },
    }
  },
]
export default function JournalTypesAdd() {
  const dispatch = useDispatch()
  const history = useHistory()
  useEffect(() => {
    dispatch(actions.formInitialize({
      categoryId: null,
      code: '',
      name: '',
      gostRef: '',
      tableNameData: '',
      reportTemplatePath: '',
      description: '',
      accountIdUnique: null,
      errorValidate: {
        code: false,
        name: false,
        categoryId: false,
        gostRef: false,
        tableNameData: false,
      }
    }, { name: formName }))
    return () => {
      dispatch(actions.formDestroy({ name: formName }))
    }
  }, [dispatch])
  const form = useSelector(state => state.form[formName] || state.form.default)
  const { values } = form
  const handleSave = (e) => {
    e.preventDefault();
    const isError = validateProps(arrProps, values)
    dispatch(actions.formChange(isError.validate, { field: 'errorValidate', name: formName }))
    if (isError.check) {
      dispatch(enqueueSnackbar({
        message: `некорректные поля`,
        options: { variant: 'error' }
      }))
      return;
    }
    dispatch(actions.formSubmitAPI({
      props: {
        categoryId: values.categoryId,
        code: values.code,
        name: values.name,
        gostRef: values.gostRef,
        tableNameData: values.tableNameData,
        reportTemplatePath: values.reportTemplatePath,
        description: values.description,
        accountIdUnique: values.accountIdUnique || null,
      },
      url: journalTypesAddOne.path,
      method: journalTypesAddOne.type,
      history: history
    }, formName))
  };
  return (
    <div className='App-paper'>
      <form autoComplete="off" onSubmit={handleSave}>
        <SimpleAdd formName={formName} arr={arrProps} title='Добавить тип журнала' gridProps={{ xs: 12, xl: 6, lg: 6 }} />
        <Button color="primary" onClick={() => history.goBack()}>Назад </Button>
        <Button type="submit" color="primary">Сохранить</Button>
      </form>
    </div>
  );
}
